import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { CookiesProvider } from 'react-cookie'
import ReactGA from 'react-ga';
import App from "./App";
import './index.css';
const currentPathname = window.location.pathname
const isWorkDetailPage = /^\/work\/\d+\//.test(currentPathname)
ReactGA.initialize('G-NZMSS8WJ6K'); // add your tracking id here.

if (!isWorkDetailPage) {
  ReactGA.pageview(window.location.pathname + window.location.search);
}

const REACT_PUBLIC_GOOGLE_CLIENT_ID = "257588356951-a4r97tedi8o8gdshjh1mddalolv460td.apps.googleusercontent.com";

export default function Root() {
  return (
    <GoogleOAuthProvider clientId={REACT_PUBLIC_GOOGLE_CLIENT_ID}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </GoogleOAuthProvider>
  )
}

ReactDOM.render(<Root />, document.getElementById('oppdb'));
